import { unescapeXml } from '@/lib/utils';
import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import UnsupportedEditableNodeView from './unsupported-editable-node-view';

export const UnsupportedEditableNodeHeadless = Node.create({
    name: 'unsupportedEditable',

    group: 'block',

    atom: true,

    selectable: true,

    draggable: true,

    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => element.getAttribute('id'),
                renderHTML: attributes => {
                    if (attributes.id) {
                        return { id: attributes.id };
                    }
                    return {};
                },
            },
            content: {
                default: '',
                parseHTML: element => {
                    const html = element instanceof HTMLElement ? element.innerHTML : '';
                    return unescapeXml(html);
                },
                renderHTML: attributes => ({
                    'data-content': attributes.content,
                }),
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'unsupported-editable',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['unsupported-editable', { ...HTMLAttributes }];
    },
});

export const UnsupportedEditableNode = UnsupportedEditableNodeHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(UnsupportedEditableNodeView);
    },
});

export default UnsupportedEditableNode;
